import React from 'react';
import { skillCategories } from './skillsData';
import { motion } from 'framer-motion';

const Skills = () => {
    return (
        <div id="skills" className="Container">
            <div className="SectionTitle">My Skills</div>

            <div className="skills-themed-container">
                {skillCategories.map((category) => (
                    <div key={category.id} className="skill-category-block">
                        <div className="skill-category-header">
                            <h3 className="skill-category-title">
                                {category.title}
                            </h3>
                            {category.badge && (
                                <span className="company-badge" style={{ fontSize: "0.75rem", padding: "3px 10px" }}>
                                    {category.badge}
                                </span>
                            )}
                        </div>

                        <div className="skill-cards-grid">
                            {category.skills.map((stack, index) => (
                                <motion.div 
                                    key={index}
                                    whileHover={{ scale: 1.08, y: -4 }}
                                    transition={{ type: "spring", stiffness: 350 }}
                                    className="skill-card-item"
                                >
                                    <img src={stack.img} alt={stack.name} />
                                    <span>{stack.name}</span>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Skills;